import { Card, CardContent, Divider } from '@billda/design-system';
import { ReactNode } from 'react';
import { GangMemberHeader } from './GangMemberHeader';

interface GangMemberConfigCardProps {
  fullName: string;
  email: string;
  role: 'leader' | 'member';
  description?: string;
  children: ReactNode;
}

export const GangMemberConfigCard = ({
  fullName,
  email,
  role,
  description,
  children,
}: GangMemberConfigCardProps) => {
  return (
    <Card
      className="mb-4"
      data-testid={`member-config-card-${fullName.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <CardContent className="pt-4">
        <GangMemberHeader fullName={fullName} email={email} role={role} />
        {description ? (
          <p className="type-body-md mb-4 text-content-secondary">
            {description}
          </p>
        ) : null}
        <Divider className="mb-4" />
        {children}
      </CardContent>
    </Card>
  );
};
